import FrontPage from './components/FrontPage.vue'
import ComponentPage from './components/ComponentPage.vue'
import CategoryPage from './components/CategoryPage.vue';
import { i18n } from "./translations/i18n";

export const routes = [
    { name: 'frontpage', path: '/', component: FrontPage },
    { name: 'componentpage_subcomponent', path: '/:categoryName/:componentName/:view/:dataType/:subComponent', component: ComponentPage },
    { name: 'componentpage_datatype', path: '/:categoryName/:componentName/:view/:dataType', component: ComponentPage },
    { name: 'componentpage_view', path: '/:categoryName/:componentName/:view', component: ComponentPage },
    { name: 'componentpage', path: '/:categoryName/:componentName', redirect: to => {
            
            // Add default redirection target, e.g. /talo/ is redirected to /talo/katunakyma
            let view = ""
            if (i18n.messages[i18n.locale].hellovue.view.street_view) {
                view = i18n.messages[i18n.locale].hellovue.view.street_view
            }
            return '/:categoryName/:componentName/' + view;

        } 
    },
    { name: 'categorypage', path: '/:categoryName', component: CategoryPage }
];
